import { Directive, inject, input } from '@angular/core';
import { Router } from '@angular/router';
@Directive({
  selector: '[inexpNavigation]',
  host: {
    '(keydown.enter)': 'handleNavigation($event)',
    '(click)': 'handleNavigation($event)',
  },
})
export class NavigationDirective {
  inexpNavigation = input<string>('');
  isExternal = input<boolean>(false);
  private readonly _router = inject(Router);

  handleNavigation(event: KeyboardEvent): void {
    event.preventDefault();
    if (this.inexpNavigation()) {
      if (this.isExternal()) {
        window.open(this.inexpNavigation(), '_blank');
      } else {
        this._router.navigate([this.inexpNavigation()]);
      }
    }
  }
}
